<template>
    <v-autocomplete
        :id="'district' + this._uid"
        ref="districtDadata"
        v-model="value"
        :items="items"
        :search-input.sync="search"
        autocomplete="false"
        label="Районы с запретом на новый бизнес"
        item-value="kladr_id"
        item-text="value"
        multiple
        small-chips
        deletable-chips
        validate-on-blur
        hide-no-data
        no-filter
    ></v-autocomplete>
</template>

<script>
import $ from 'jquery';
import 'suggestions-jquery';
export default {
    props: {
        model: {
            default: []
        },
        items: {
            default: []
        },
        options: {
            default: () => ({
                //token: 'd41d36d28500ad106eddbdc20258ec57d945f1d1',
                token: '14a86f53aaa54b7bb802c4f1b895a59ba2006b30',
                type: 'ADDRESS',
                addon: 'spinner',
                count: 5,
                minChars: 2,
                floating: true,
                bounds: 'area-city',
            }),
        },
        short: {
            default: false,
        },
    },

    data: () => ({
        element: null,
        init: false,
        search: '',
        value: [],
        flatTip: false
    }),

    mounted() {
        this.options.onSelect = suggestion => this.onSelectArea(suggestion);
        this.value = this.model;
        this.element = $('#district'+this._uid);
        this.$nextTick(() => {
            this.initSuggestion();
        });
    },

    destroyed() {
        this.destroySuggestion();
    },

    watch: {
        value() {
            this.$emit('updateModel', this.value);
        },
        model() {
            this.value = this.model;
        }
    },

    methods: {
        initSuggestion() {
            if (this.init) {
                return;
            }
            this.element.suggestions(this.options).suggestions().fixData();
            this.init = true;
        },
        destroySuggestion() {
            this.element.suggestions().dispose();
        },
        onSelectArea(suggestion) {
            this.search = '';
            if (this.items.findIndex((el) => el.kladr_id === suggestion.data.kladr_id) === -1) {
                this.items.push({
                    value: suggestion.value,
                    kladr_id: suggestion.data.kladr_id
                });
            }
            if (this.value === undefined) {
                this.value = [];
            }
            this.value.push(suggestion.data.kladr_id);

            // Закрываем меню автокомплита
            this.$nextTick(() => {
                this.$refs.districtDadata.isMenuActive = false;
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/fields/DistrictDadataAutocomplete.vue